import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "@/components/landing/Reveal";
import { FAQS } from "@/lib/site";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-slate-900 scroll-mt-20">
    <div className="max-w-3xl mx-auto px-6 sm:px-8">
      <SectionHeading label="Questions" title="Everything you're wondering, answered" />
      <Accordion type="single" collapsible className="space-y-4">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="bg-slate-950 rounded-2xl border border-slate-800 px-7 overflow-hidden">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-base sm:text-lg font-bold text-white py-6 hover:no-underline hover:text-blue-400 transition-colors">
              {f.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="text-sm sm:text-base text-slate-400 leading-relaxed pb-6">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
